<div class="dialog-viewer">
    <h2 mat-dialog-title>Create Booking</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Simulator</mat-label>
                            <input required matInput readonly name="simulatorId" id="simulatorId"
                                placeholder="Simulator" [value]="simulator.bayName" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Start Time</mat-label>
                            <input required readonly matInput name="startTime" id="startTime" placeholder="Start Time"
                                type="datetime" formControlName="startTime" />
                            <mat-error *ngIf="form.get('startTime').errors?.required">Start Time is required</mat-error>
                            <mat-error *ngIf="form.get('startTime').errors?.validationErrors">
                                {{ form.get("startTime").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Duration</mat-label>
                            <mat-select required formControlName="duration" matInput name="duration" id="duration"
                                placeholder="Duration" (selectionChange)="setEndTimeAndTotalPrice($event.value)">
                                <mat-option *ngFor="let duration of availableDurations"
                                    [value]="duration">{{formatDuration(duration.durationMinutes)}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('duration').errors?.required">Duration is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Status</mat-label>
                            <mat-select required formControlName="status" matInput name="status" id="status"
                                placeholder="Status">
                                <mat-option *ngFor="let status of bookingStatusEnumKeys"
                                    [value]="bookingStatusEnum[status]">
                                    <ng-container
                                        *ngIf="status === bookingStatusEnum[3]">Closed/Maintenance</ng-container>
                                    <ng-container *ngIf="status !== bookingStatusEnum[3]">{{ status }}</ng-container>
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('status').errors?.required">Status is required
                            </mat-error>
                            <mat-error *ngIf="form.get('status').errors?.validationErrors">
                                {{ form.get("status").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Email</mat-label>
                            <input matInput name="email" id="email" placeholder="Email" type="email"
                                formControlName="email" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Customer Name</mat-label>
                            <input required matInput name="customerName" id="customerName" placeholder="Customer Name"
                                type="text" formControlName="customerName" />
                            <mat-error *ngIf="form.get('customerName').errors?.required">Customer Name is required
                            </mat-error>
                            <mat-error *ngIf="form.get('customerName').errors?.validationErrors">
                                {{ form.get("customerName").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row align-items-baseline">
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Phone Number</mat-label>
                            <input matInput name="phoneNumber" id="phoneNumber" placeholder="Phone Number"
                                type="tel" formControlName="phoneNumber" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <mat-label>Number of Golfers</mat-label>
                            <input matInput name="participants" id="participants" placeholder="Number of Golfers"
                                type="number" min="1" max="6" formControlName="participants" />
                            <mat-error *ngIf="form.get('participants').errors?.required">Number of Golfers is required
                            </mat-error>
                            <mat-error *ngIf="form.get('participants').errors?.validationErrors">
                                {{ form.get("participants").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Addons</mat-label>
                            <mat-select multiple formControlName="addons" (selectionChange)="onAddonSelectionChange($event)">
                                <mat-option *ngFor="let addon of availableAddons" [value]="addon">
                                    {{addon.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row align-items-baseline">
                    <div class="col-4">
                        <mat-checkbox #priceOverride>Price Override</mat-checkbox>
                    </div>
                    <ng-container *ngIf="priceOverride.checked">
                        <div class="col-4">
                            <mat-form-field>
                                <span matPrefix>$ &nbsp;</span>
                                <mat-label>Price Override</mat-label>
                                <input matInput name="priceOverride" id="priceOverride" placeholder="Price Override"
                                    type="number" min="0" formControlName="priceOverride" />
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field>
                                <mat-label>Price Override Reason</mat-label>
                                <input matInput name="priceOverrideReason" id="priceOverrideReason"
                                    placeholder="Price Override Reason" type="text"
                                    formControlName="priceOverrideReason" />
                            </mat-form-field>
                        </div>
                    </ng-container>
                </div>
                <hr />
                <div class="row mt-2">
                    <h3 class="col">Total: ${{form.get('totalPrice').value | number:'1.2-2'}}</h3>
                </div>
            </div>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="row">
                <div class="text-center">
                    <button mat-raised-button type="submit" [disabled]="isLoading || !form.valid">Save</button>
                    <button mat-raised-button class="secondary" 
                        [disabled]="!form.valid || isLoading || !form.get('email').value" 
                        [matTooltip]="!form.get('email').value ? 'An email is required when submitting with a payment' : ''"
                        type="button" 
                        (click)="onSubmitWithPayment()">Save With Payment</button>
                    <button mat-raised-button class="warning" type="button" (click)="dialogRef.close('cancel')" color="warn"
                        [disabled]="isLoading">Cancel</button>
                </div>
            </div>

        </mat-dialog-actions>
    </form>
</div>